export default __webpack_public_path__ + "static/media/stories-icon-2.99ee0307.svg";